<div class="col-span-3 relative -mr-1">
  <input name="amount" [(ngModel)]="input" class="w-full rounded-md border-2 text-right py-0.5 pl-1 pr-4"
         [ngClass]="{'text-red-600': (input ?? 0) < 0 && colored, 'text-green-700': (input ?? 0) > 0 && colored}"
         type="tel" [placeholder]="placeholder" [readonly]="readonly"
         [currencyMask]="{ prefix: '', thousands: '.', decimal: ',', allowNegative: negative, inputMode: NgxCurrencyInputMode.Natural, nullable: true }">
  <span class="absolute right-1 top-1/2 -translate-y-1/2">&euro;</span>
</div>
